import React from "react"
import App from "./App"
import { BrowserRouter } from "react-router-dom"
import theme from "./branding/theme"
import { ThemeProvider } from "@mui/material/styles"
import { SnackbarProvider } from "notistack"
import { createRoot } from "react-dom/client"
// import { NoSsr } from "@mui/material"

const root = createRoot(document.getElementById("root"))

// I disabled strict mode for better performance
root.render(
  // <React.StrictMode>
  //   {/* // <NoSsr> */}
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <SnackbarProvider
          maxSnack={3}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <App />
        </SnackbarProvider>
      </ThemeProvider>
    </BrowserRouter>
  //   {/* // </NoSsr> */}
  // </React.StrictMode>
)
